import request from '@/utils/request'


//查询列表
export function searchList(data) {
  return request({
    url: '/admin/frontBizType/list',
    method: 'post',
    data:data
  })
}

//添加
export function addRecord(data) {
  return request({
    url: '/admin/frontBizType/add',
    method: 'post',
    data:data
  })
}

//删除，设置成无效
export function deleteRecord(params) {
  return request({
    url: '/admin/frontBizType/delete',
    method: 'get',
    params: params
  })
}

//查找所有门店数据接口
export function frontBizTypeList(data) {
  return request({
    url: '/admin/frontBizType/allList',
    method: 'post',
    data:data
  })
}






// WEBPACK FOOTER //
// ./src/api/frontBizType.js